/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, month: NonNullable<unknown> }} Calendar_Quota_Month_Other_OtherInputs */

const fr_calendar_quota_month_other_other = /** @type {(inputs: Calendar_Quota_Month_Other_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cours restants en ${i?.month}`)
};

/**

* @param {Calendar_Quota_Month_Other_OtherInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_month_other_other = /** @type {((inputs: Calendar_Quota_Month_Other_OtherInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Month_Other_OtherInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_month_other_other(inputs)
});